import gql from 'fraql'

export const COURIER_IS_RETURNING = gql`
    query {
        courierIsReturning
    }
`

export const COURIER_RETURNED_TO_REST_POINT = gql`
    mutation courierReturnedToRestPoint ($position: JSON!) {
        courierReturnedToRestPoint(input: {position: $position}) {
            boolean
        }
    }
`



// WEBPACK FOOTER //
// ./src/constants/graphql/courier.js